import { render } from "./TransferRequestModal.vue?vue&type=template&id=72d936a2&scoped=true"
import script from "./TransferRequestModal.vue?vue&type=script&lang=js"
export * from "./TransferRequestModal.vue?vue&type=script&lang=js"

import "./TransferRequestModal.vue?vue&type=style&index=0&id=72d936a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d936a2"]])

export default __exports__